import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireDatabase } from 'angularfire2/database';
import { AuthService } from './../../services/auth.service';
import { NavbarService } from './../../services/navbar-service.service';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';

// declare jQuery
import * as $ from 'jquery';
import { RouterConfigLoader } from '@angular/router/src/router_config_loader';
import { SHOW_ANIMATION } from '@angular/material';
import { MyListService } from '../../services/my-list.service';
import { trigger, state, transition } from '@angular/animations';

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.css']
})
export class GameComponent implements OnInit, OnDestroy {

  progress = 0;

  // Global functions
  hardAnswer: any;
  capitilizeSentence: any;

  constructor(
    public auth: AuthService,
    public database: AngularFireDatabase,
    public route: ActivatedRoute,
    public router: Router,
    public navbarService: NavbarService,
    public myListService: MyListService
  ) {
    navbarService.hide();
  }

  again() {
    location.reload();
  }

  ngOnDestroy() {
    this.navbarService.show();
  }

  ngOnInit() {
    const that = this;

    that.hardAnswer = hardAnswer;
    that.capitilizeSentence = capitilizeSentence;

    console.log('Game script starting');

    const codeInput = this.route.snapshot.paramMap.get('key');
    const listStatus = this.route.snapshot.paramMap.get('accessType');

    // hvis listen er offentlig
    if (listStatus === 'pu') {
      // henter data fra databasen
      this.database.object('/codes/' + codeInput).valueChanges().take(1).subscribe(foko => {
        getData(foko);
      });
      // hvis listen er privat
    } else if (listStatus === 'pr') {
      console.log('The list is private. Retrieving foko from MyListService');

      const fokoRef = this.auth.user$.switchMap(user => {
        return this.database.object('users/' + user.uid + '/glossaries/' + codeInput).valueChanges();
      });

      fokoRef.take(1).subscribe(foko => {
        console.log(foko);
        getData(foko);
      });

    }

    startLoader();

    console.log(codeInput);
    console.log(listStatus);

    const question = document.getElementById('mainHeader');
    const modal = document.getElementById('pre-gameModal');
    let correctBtn;
    const buttons = [
      document.getElementById('button1'),
      document.getElementById('button2'),
      document.getElementById('button3'),
      document.getElementById('button4')
    ];
    const buttonDiv = document.getElementsByClassName('btnDiv');

    let listName;
    let mainLanguage;
    let secondLanguage;
    let date;
    let amount;
    let name;
    let uid;

    let currentQuestion = 1;

    let difficulty;
    let mainArray = [];
    let secondArray = [];
    let mainArrayKeep;
    let secondArrayKeep = [];

    let intArray = [];
    let refillArray = [];
    let correctInt = 0;
    let correctPercent;
    let wrongPercent;
    let roundBar;

    const questionArray = [];
    const wrongArray = [];
    const correctArray = [];

    const amountText = document.getElementById('amountText');
    const mainLanguageText = document.getElementById('mainLanguageText');
    const secondLanguageText = document.getElementById('secondLanguageText');
    const difficultyText = document.getElementById('difficultyText');
    const dateText = document.getElementById('dateText');
    const nameText = document.getElementById('nameText');
    const LanguageHeader1 = document.getElementById('LanguageHeader1');
    const LanguageHeader2 = document.getElementById('LanguageHeader2');
    const NameHeader = document.getElementById('NameHeader');

    const table = <HTMLInputElement>document.getElementById('peekList');
    const showBtn = document.getElementById('showMore');
    const overviewDiv = document.getElementById('overviewDiv');
    const startBtn = document.getElementById('startBtn');
    const mainDiv = document.getElementById('mainDiv');
    const scoreTxt = document.getElementById('scoreTxt');
    const listNameTxt2 = document.getElementById('listNameTxt2');
    const resultDiv = document.getElementById('resultDiv');
    const resultsInnerDiv = document.getElementById('results');
    const resultsTable = document.getElementById('resultsTable');
    const percentTxt = document.getElementById('percentText');
    const matProgressBar = document.getElementById('matProgressBar');

    const correctBar = document.getElementById('correctBar');

    function getData(data) {
      if (data) {
        listName = data.listname;
        mainLanguage = data.mainLanguage;
        secondLanguage = data.secondLanguage;
        date = data.date;
        amount = data.amount;
        name = data.name;
        uid = data.UID;
        difficulty = data.difficulty;

        mainArrayKeep = data.mainArray;
        mainArray = mainArrayKeep.slice();
        secondArrayKeep = data.secondArray;
        secondArray = secondArrayKeep.slice();

        amountText.innerHTML = amount;
        mainLanguageText.innerHTML = mainLanguage;
        secondLanguageText.innerHTML = secondLanguage;
        dateText.innerHTML = date;
        nameText.innerHTML = name;
        difficultyText.innerHTML = difficulty;

        LanguageHeader1.innerHTML = mainLanguage + ':';
        LanguageHeader2.innerHTML = secondLanguage + ':';
        NameHeader.innerHTML = listName;
        listNameTxt2.innerHTML = listName;

        if (difficulty === 'Normal') {
          scoreTxt.innerHTML = currentQuestion + '/' + amount * 2;
        } else {
          scoreTxt.innerHTML = currentQuestion + '/' + amount;
        }

        previewList();
        stopLoader();

        // progress bar
        const canvas = document.createElement('canvas');
        const progress = document.createElement('p');
        document.getElementById('percentLi').appendChild(canvas);
        document.getElementById('percentLi').appendChild(progress);
        canvas.height = 106;
        canvas.width = 106;
        progress.innerHTML = data.percent + '%';
        const context = canvas.getContext('2d');
        const al = data.percent;
        const start = 4.72;
        const cw = 54;
        const ch = 54;
        let diff;
        diff = al / 100 * Math.PI * 2;
        context.clearRect(0, 0, 400, 200);
        context.beginPath();
        context.arc(cw, ch, 50, 0, 2 * Math.PI, false);
        context.strokeStyle = '#4285F4'; // for border color
        context.lineWidth = 2;
        context.stroke(); // Stroke function
        context.fillStyle = '#000'; // Text color
        context.strokeStyle = '#4285F4';
        context.textAlign = 'center';
        context.lineWidth = 4;
        context.font = '120pt Verdana';
        context.beginPath();
        context.arc(cw, ch, 50, start, diff + start, false);
        context.stroke();

        intArray = Object.keys(mainArray);
        shuffle(intArray);

        refillArray = Object.keys(mainArray);
        shuffle(refillArray);

        updateUI();
      } else {
        stopLoader();

        alert('error');
      }
    }

    // sjekker om du svarte riktig
    buttons[0].onclick = function () {
      checkBtn(0);
    };
    buttons[1].onclick = function () {
      checkBtn(1);
    };
    buttons[2].onclick = function () {
      checkBtn(2);
    };
    buttons[3].onclick = function () {
      checkBtn(3);
    };

    function checkBtn(btnNum) {
      if (correctBtn === btnNum) {
        // du svarte riktig
        correctInt++;
        newQuestion();
      } else {
        // du svarte feil
        for (let i = 0; i < buttonDiv.length; i++) {
          if (i !== correctBtn) {
            (<HTMLElement>buttonDiv[i]).style.opacity = "0";
          }
        }
        console.log('Feil');
        wrongArray.push(buttons[btnNum].innerHTML); // Adding to wrong array
        correctArray.push(buttons[correctBtn].innerHTML); // Adding to correct answer array
        setTimeout(function () { newQuestion(); }, 2000);
      }
    }

    showBtn.onclick = function () {
      if (table.style.display !== 'table') {
        const $target = $('html,body');
        $target.animate({ scrollTop: $target.height() }, 500);
        table.style.display = 'table';
        showBtn.style.position = 'relative';
        showBtn.style.setProperty('margin-bottom', '50px', 'important');
        showBtn.style.backgroundImage = 'url(\'assets/arrowUp.png\')';
        showBtn.innerHTML = 'Hide glossaries';
      } else {
        table.style.display = 'none';
        showBtn.style.position = 'absolute';
        showBtn.style.marginBottom = '0px';
        showBtn.style.backgroundImage = 'url(assets/arrow.png)';
        showBtn.innerHTML = 'Show glossaries';
      }
    };

    (<HTMLButtonElement>startBtn).onclick = function () {
      console.log('starting the game');
      startBtn.style.display = 'none';
      overviewDiv.className = 'animated fadeOutLeftBig';
      overviewDiv.style.display = 'none';
      mainDiv.style.display = 'block';
      mainDiv.className = 'animated fadeInRightBig';
      scoreTxt.style.display = 'block';
      scoreTxt.className = 'animated fadeInRight';
      listNameTxt2.style.display = 'block';
      listNameTxt2.className = 'animated fadeIn';
      matProgressBar.style.display = "unset";
    };

    function updateUI() {
      const newSecondArray = secondArrayKeep.slice();
      let glossarySelected = 0;
      if (mainArray.length > 1) {
        glossarySelected = Math.floor(Math.random() * (mainArray.length - 1));
      }
      question.innerHTML = mainArray[glossarySelected];
      correctBtn = Math.floor(Math.random() * 4);
      // setter tekst på den rikitige knappen
      buttons[correctBtn].innerHTML = secondArray[glossarySelected];
      // fjerner den rikitige glosen fra arrayene
      mainArray.splice(glossarySelected, 1);
      newSecondArray.splice(
        newSecondArray.indexOf(secondArray[glossarySelected]),
        1
      );
      secondArray.splice(glossarySelected, 1);
      for (let i = 0; i <= 3; i++) {
        if (i !== correctBtn) {
          const ko = Math.floor(Math.random() * (newSecondArray.length - 1));
          buttons[i].innerHTML = newSecondArray[ko];
          newSecondArray.splice(ko, 1);
        }
      }
    }
    function newQuestion() {
      for (let i = 0; i < buttonDiv.length; i++) {
        (<HTMLElement>buttonDiv[i]).style.opacity = "1";
      }
      if (currentQuestion === amount) {
        if (difficulty === 'Normal') {
          (<HTMLInputElement>document.getElementById('answerInput')).value = '';
          harderQuestions();
        } else {
          scoreTxt.innerHTML = currentQuestion + '/' + amount;
          currentQuestion++;
          that.progress = (currentQuestion / amount) * 100;
          prepareResults();
        }
      } else {
        currentQuestion++;
        if (difficulty === 'Normal') {
          scoreTxt.innerHTML = currentQuestion + '/' + amount * 2;
          that.progress = (currentQuestion - 1) / (amount * 2) * 100;
        } else {
          scoreTxt.innerHTML = currentQuestion + '/' + amount;
          that.progress = (currentQuestion - 1) / amount * 100;
        }
        console.log("Progress: ", that.progress);

        shuffle(intArray);
        shuffle(refillArray);
        updateUI();
      }
    }

    function harderQuestions() {
      $('button1')
        .prop('onclick', null)
        .off('click');
      $('button2')
        .prop('onclick', null)
        .off('click');
      $('button3')
        .prop('onclick', null)
        .off('click');
      $('button4')
        .prop('onclick', null)
        .off('click');

      document.getElementById('answers').style.display = 'none';
      document.getElementById('inputAnswerDiv').style.display = 'table';

      setTimeout(function () {
        (<HTMLInputElement>document.getElementById('answerInput')).value = '';
      }, 1);

      intArray = [];
      intArray = Object.keys(mainArrayKeep);
      shuffle(intArray);

      hardQuestion();
    }

    function hardQuestion() {
      document.getElementById('answerInput').focus();
      (<HTMLInputElement>document.getElementById('answerInput')).value = '';

      question.innerHTML = mainArrayKeep[intArray[0]];
      that.progress = currentQuestion / (amount * 2) * 100;
      scoreTxt.innerHTML = currentQuestion + '/' + amount * 2;
      currentQuestion++;

      console.log("Progress: ", that.progress);
    }

    function newHardQuestion() {
      if (currentQuestion === amount * 2) {
        scoreTxt.innerHTML = currentQuestion + '/' + amount * 2;
        currentQuestion++;
        that.progress = currentQuestion / (amount * 2) * 100;
        prepareResults();
      } else {
        intArray.splice(0, 1);
        hardQuestion();
      }
    }

    function hardAnswer(answer) {
      if (answer === secondArrayKeep[intArray[0]]) {
        // Correct Answer
        correctInt++;

        newHardQuestion();
      } else {
        // Wrong Answer
        alert('feil');

        questionArray.push(mainArrayKeep[intArray[0]]);
        wrongArray.push(answer);
        correctArray.push(secondArrayKeep[intArray[0]]);

        newHardQuestion();
      }
    }

    document.getElementById('passBtn').onclick = function () {
      questionArray.push(mainArrayKeep[intArray[0]]);
      wrongArray.push('Passed');
      correctArray.push(secondArrayKeep[intArray[0]]);

      console.log('Question array: ' + questionArray);
      console.log('Wrong array: ' + wrongArray);
      console.log('Correct array: ' + correctArray);

      newHardQuestion();
    };

    function prepareResults() {
      if (difficulty === 'Normal') {
        correctPercent = correctInt / (amount * 2) * 100;
      } else {
        correctPercent = correctInt / amount * 100;
      }

      wrongPercent = 100 - correctPercent;

      // ANIMATION!!!!!!!!!!!!!
      mainDiv.style.display = 'none';
      resultDiv.style.display = 'table';
      resultsTable.style.display = 'inherit';

      correctBar.innerHTML = correctInt + ' correct';
      percentTxt.innerHTML = Math.round(correctPercent) + '%';

      setTimeout(loadBars('correctBar', correctPercent), 300);
      roundBar = setInterval(progressBar, 15);

      if (questionArray.length === 0) {
        resultsInnerDiv.style.display = 'none';

        // Congratulations animations etc
      } else {
        // Create error list
        for (let i = 0; i < questionArray.length; i++) {
          const table = <HTMLTableElement>document.getElementById('resultsTable');
          const tr = document.createElement('TR');

          const row = table.insertRow(-1);
          const cell1 = row.insertCell(0);
          const cell2 = row.insertCell(1);
          const cell3 = row.insertCell(2);

          const t1 = document.createTextNode(questionArray[i]);
          const t2 = document.createTextNode(wrongArray[i]);
          const t3 = document.createTextNode(correctArray[i]);

          if (wrongArray[i] === 'Passed') {
            cell2.style.color = '#7f7f7f';
            cell2.style.fontStyle = 'italic';
          }

          cell1.appendChild(t1);
          cell2.appendChild(t2);
          cell3.appendChild(t3);
        }
      }

      // Upload progress to firebase
      if (listStatus === 'pr') {
        that.database.object('users/' + that.myListService.uid + '/glossaries/' + codeInput)
          .update({ 'percent': correctPercent }).then(() => {
            console.log('Progress uploaded to firebase');
          }).catch((error) => {
            error.log("Failed to upload to firebase", error);
          });
      }

    }

    $('#inputAnswerDiv').keyup(function (event) {
      const textBox = event.target;
      const start = textBox.selectionStart;
      const end = textBox.selectionEnd;
      textBox.value =
        textBox.value.charAt(0).toUpperCase() + textBox.value.slice(1);
      textBox.setSelectionRange(start, end);
    });

    function previewList() {
      for (let i = 0; i < mainArray.length; i++) {
        const table = <HTMLTableElement>document.getElementById('peekList');

        const tr = document.createElement('TR');

        const row = table.insertRow(-1);
        const cell1 = row.insertCell(0);
        const cell2 = row.insertCell(1);

        const t1 = document.createTextNode(mainArray[i]);
        const t2 = document.createTextNode(secondArray[i]);

        cell1.appendChild(t1);
        cell2.appendChild(t2);
      }
    }

    function capitilizeSentence(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function shuffle(a) {
      let j, x, i;
      for (i = a.length; i; i--) {
        j = Math.floor(Math.random() * i);
        x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
      }
    }

    function openPreSettings() {
      $(modal).css({ display: 'block' });
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    };

    // When the user clicks on (x), close the modal
    document.getElementById('quitBtn').onclick = function () {
      modal.style.display = 'none';
    };

    function startLoader() {
      document.getElementById('darkScreen').style.display = 'block';
      document.getElementById('loaderDiv').style.display = 'inline-block';
    }

    function stopLoader() {
      document.getElementById('darkScreen').style.display = 'none';
      document.getElementById('loaderDiv').style.display = 'none';
    }

    // function toTitleCase(str) {
    //    return str.replace(/\w\S*/g, function(txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    // }


    $(document).on('keypress', function (e) {
      if (e.keyCode === 49) {
        //      #1
        console.log('Button[0]: 1');
        buttons[0].click();
      } else if (e.keyCode === 50) {
        //      #2
        console.log('Button[1]: 2');
        buttons[1].click();
      } else if (e.keyCode === 51) {
        //      #3
        console.log('Button[2]: 3');
        buttons[2].click();
      } else if (e.keyCode === 52) {
        //      #4
        console.log('Button[3]: 4');
        buttons[3].click();
      }
    });

    function loadBars(ID, percent) {
      const bar = document.getElementById(ID);
      let width = 1;
      const id = setInterval(frame, 15);

      function frame() {
        if (width >= percent) {
          clearInterval(id);
          if (width === 100) {
            bar.style.borderRadius = '5px';
          }
        } else {
          width++;
          bar.style.width = width + '%';
        }
      }
    }

    // For the circular progressbar
    const canvas = <HTMLCanvasElement>document.getElementById('gradeCanvas');
    const context = canvas.getContext('2d');
    let al = 0;
    const start = 4.72;
    const cw = context.canvas.width / 2;
    const ch = context.canvas.height / 2;
    let diff;

    function progressBar() {
      diff = al / 100 * Math.PI * 2;
      context.clearRect(0, 0, 400, 200);
      context.beginPath();
      context.arc(cw, ch, 150, 0, 2 * Math.PI, false);
      context.fillStyle = '#FFF'; // for color of inner circle
      context.fill(); // fill function
      context.strokeStyle = '#99db98'; // for border color
      context.stroke(); // Stroke function
      context.fillStyle = '#000'; // Text color
      context.strokeStyle = '#33B732';
      context.textAlign = 'center';
      context.lineWidth = 45;
      context.font = '120pt Verdana';
      context.beginPath();
      context.arc(cw, ch, 150, start, diff + start, false);
      context.stroke();

      if (al >= correctPercent) {
        clearTimeout(roundBar);

        if (correctPercent >= 90 && correctPercent <= 100) {
          // 6
          context.fillText('6', cw, ch + 65);
        } else if (correctPercent >= 80 && correctPercent <= 90) {
          // 5
          context.fillText('5', cw, ch + 65);
        } else if (correctPercent >= 70 && correctPercent <= 80) {
          // 4
          context.fillText('4', cw, ch + 65);
        } else if (correctPercent >= 60 && correctPercent <= 70) {
          // 3
          context.fillText('3', cw, ch + 65);
        } else if (correctPercent >= 40 && correctPercent <= 60) {
          // 2
          context.fillText('2', cw, ch + 65);
        } else if (correctPercent <= 39) {
          // 1
          context.fillText('1', cw, ch + 65);
        }
      }

      al++;
    }

    // ## ngOnInit() end
  }
  enterBtnpressed() {
    const input = (<HTMLInputElement>document.getElementById('answerInput')).value;
    this.hardAnswer(this.capitilizeSentence(input));
  }
}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/game/game.component.ts